import React, { useState } from "react";
import {
  Drawer,
  Box,
  Typography,
  FormControlLabel,
  Checkbox,
  Radio,
  RadioGroup,
  Divider,
  IconButton,
  Button,
} from "@mui/material";
import FilterListIcon from "@mui/icons-material/FilterList";

const ResortSidebarDrawer = ({ filters, setFilters }) => {
  const [open, setOpen] = useState(false);

  const allAmenities = [
    "Airconditioner",
    "Festival",
    "Free Wifi",
    "Gym",
    "Mountain Bike",
    "Personal Guide",
    "Sightseeing",
    "Swimming Pool"
  ];

  const toggleDrawer = (state) => () => {
    setOpen(state);
  };

  // Handle checkbox toggles
  const handleCheckboxChange = (type, value) => {
    setFilters((prev) => {
      const current = prev[type] || [];
      return {
        ...prev,
        [type]: current.includes(value)
          ? current.filter((v) => v !== value)
          : [...current, value],
      };
    });
  };

  // Handle price selection
  const handlePriceChange = (event) => {
    const range = JSON.parse(event.target.value);
    setFilters((prev) => ({ ...prev, priceRange: range }));
  };

  // Handle rating selection
  const handleRatingChange = (event) => {
    const value = parseInt(event.target.value);
    setFilters((prev) => ({ ...prev, average_rating: value }));
  };

  const list = (
    <Box sx={{ width: 280, p: 2 }} role="presentation">
      <Typography variant="h6" gutterBottom>
        Filters
      </Typography>

      {/* Price Filter */}
      <Typography variant="subtitle1">Price Per Night</Typography>
      <RadioGroup
        value={filters.priceRange ? JSON.stringify(filters.priceRange) : ""}
        onChange={handlePriceChange}
      >
        {[[0, 2000], [2000, 4000], [4000, 6000], [6000, 8000]].map((range, i) => (
          <FormControlLabel
            key={i}
            value={JSON.stringify(range)}
            control={<Radio />}
            label={`${range[0]} - ${range[1]} /-`}
          />
        ))}
      </RadioGroup>

      <Divider sx={{ my: 2 }} />

      {/* Average Rating Filter */}
      <Typography variant="subtitle1">Average Rating</Typography>
      <RadioGroup
        value={filters.average_rating || ""}
        onChange={handleRatingChange}
      >
        {[5, 4, 3, 2, 1].map((star) => (
          <FormControlLabel
            key={star}
            value={star}
            control={<Radio />}
            label={`${star}★ & Up`}
          />
        ))}
      </RadioGroup>

      <Divider sx={{ my: 2 }} />

      {/* Amenities Filter */}
      <Typography variant="subtitle1">Amenities</Typography>
      {allAmenities.map((amenity) => (
        <FormControlLabel
          key={amenity}
          control={
            <Checkbox
              checked={filters.amenities?.includes(amenity) || false}
              onChange={() => handleCheckboxChange("amenities", amenity)}
            />
          }
          label={amenity}
        />
      ))}

      <Divider sx={{ my: 2 }} />

      {/* Room Views */}
      <Typography variant="subtitle1">Room Views</Typography>
      {["Pool View", "Sea View", "Garden View", "Lake View"].map((view) => (
        <FormControlLabel
          key={view}
          control={
            <Checkbox
              checked={filters.roomViews?.includes(view) || false}
              onChange={() => handleCheckboxChange("roomViews", view)}
            />
          }
          label={view}
        />
      ))}

      {/* Buttons */}
      <Box sx={{ mt: 3, display: "flex", gap: 1 }}>
        <Button
          variant="contained"
          color="primary"
          fullWidth
          onClick={toggleDrawer(false)}
        >
          Apply
        </Button>
        <Button
          variant="outlined"
          color="secondary"
          fullWidth
          onClick={() =>
            setFilters({
              priceRange: null,
              average_rating: null,
              amenities: [],
              roomViews: [],
              propertyTypes: [],
              houseRules: [],
            })
          }
        >
          Clear
        </Button>
      </Box>
    </Box>
  );

  return (
    <div className="mobile_filter">
      {/* Filter Button */}
      <IconButton
        onClick={toggleDrawer(true)}
        color="inherit"
        edge="start"
        sx={{ m: 0 }}
      >
        <FilterListIcon />
        <span style={{ fontSize: "1rem", fontWeight: "600" }}>Filter</span>
      </IconButton>

      {/* Drawer */}
      <Drawer anchor="left" open={open} onClose={toggleDrawer(false)}>
        {list}
      </Drawer>
    </div>
  );
};

export default ResortSidebarDrawer;
